import { Bar, CartesianGrid, ComposedChart, Line, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { ChartTooltip } from "./ChartTooltip";

const M = { top: 8, right: 4, left: 0, bottom: 0 };
const AX = { stroke: "hsl(var(--muted-foreground))", fontSize: 12, tickLine: false, axisLine: false };
const CURSOR = { fill: "hsl(var(--primary) / 0.06)" };

// نمط أعمدة: أعمدة بتدرّج رأسي + زوايا مدوّرة + خط تأخير ذهبي.
export const ChartBars = ({ data }) => (
  <ResponsiveContainer width="100%" height="100%">
    <ComposedChart data={data} margin={M}>
      <defs>
        <linearGradient id="presentBar" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%"   stopColor="#34d399" />
          <stop offset="100%" stopColor="#059669" />
        </linearGradient>
        <linearGradient id="absentBar" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%"   stopColor="#fb7185" />
          <stop offset="100%" stopColor="#e11d48" />
        </linearGradient>
      </defs>
      <CartesianGrid strokeDasharray="4 6" stroke="hsl(var(--border))" vertical={false} />
      <XAxis dataKey="label" {...AX} />
      <YAxis width={28} allowDecimals={false} {...AX} />
      <Tooltip content={<ChartTooltip />} cursor={CURSOR} />
      <Bar dataKey="present" fill="url(#presentBar)" radius={[10, 10, 0, 0]} maxBarSize={22} animationDuration={700} />
      <Bar dataKey="absent"  fill="url(#absentBar)"  radius={[10, 10, 0, 0]} maxBarSize={22} animationDuration={700} />
      <Line type="monotone" dataKey="late" stroke="#f59e0b" strokeWidth={2.5} strokeLinecap="round"
            dot={{ r: 3, fill: "#f59e0b" }} animationDuration={700} />
    </ComposedChart>
  </ResponsiveContainer>
);
